if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.weekly = 'weeklyOpens' in this.dataset;
      if (this.weekly) {
        this.endDate = this.weeklyTarget();
        if (!this.endDate) {
          this.hideSection();
          return;
        }
        this.hidden = false;
      } else {
        this.endDate = new Date(this.dataset.endDate).getTime();
      }
      if (!Number(this.endDate)) return;

      window.initLazyScript(this, this.init.bind(this));
    }

    /**
     * Haftalık satış takvimi: açılıştan önce açılışa, kapanıştan sonra sıradaki satışın açılışına sayar.
     * Satış açıkken ya da sayılacak tarih yokken null döner ve bölüm gizlenir.
     */
    weeklyTarget() {
      const now = Date.now();
      const opens = Date.parse(this.dataset.weeklyOpens);
      const closes = Date.parse(this.dataset.weeklyCloses);
      const nextOpens = Date.parse(this.dataset.weeklyNextOpens);

      if (opens > now) return this.withWeek(opens, this.dataset.weeklyWeek);
      if (closes <= now && nextOpens > now) return this.withWeek(nextOpens, this.dataset.weeklyNextWeek);

      return null;
    }

    withWeek(target, week) {
      const section = this.closest('.shopify-section') || document;
      section.querySelectorAll('.js-weekly-week').forEach((el) => {
        el.textContent = Number(week) > 0 ? week : '';
      });

      return target;
    }

    hideSection() {
      const section = this.closest('.shopify-section');
      if (section) section.hidden = true;
    }

    init() {
      this.daysEl = this.querySelector('.js-days');
      this.hoursEl = this.querySelector('.js-hours');
      this.minsEl = this.querySelector('.js-mins');
      this.secsEl = this.querySelector('.js-secs');

      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;
      this.day = 24 * this.hour;

      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
    }

    timer() {
      const timeDiff = this.endDate - new Date();

      if (timeDiff < 0) {
        clearInterval(this.interval);
        // Haftalık sayaç açılışta kaybolur; sayfa yenilenince sıradaki hedef seçilir.
        if (this.weekly) this.hideSection();
        return;
      }

      const days = Math.floor(timeDiff / this.day);
      const hours = Math.floor(timeDiff / this.hour);
      const mins = Math.floor(timeDiff / this.minute);
      const secs = Math.floor(timeDiff / this.second);

      this.daysEl.textContent = days;
      this.hoursEl.textContent = hours - days * 24;
      this.minsEl.textContent = mins - hours * 60;
      this.secsEl.textContent = secs - mins * 60;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
